{
  "address": "CRGhjZGv6ttKt8AiqEZd2ZBW7Kp14zXUKjUykoR29LbN",
  "metadata": {
    "name": "coordinator",
    "version": "1.0.7",
    "spec": "0.1.0",
    "description": "Coordinator program for CrunchDAO"
  },
  "instructions": [
    {
      "name": "accept_coordinator_authority",
      "discriminator": [
        236,
        35,
        149,
        237,
        106,
        67,
        58,
        219
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": []
    },
    {
      "name": "add_model",
      "discriminator": [
        229,
        104,
        246,
        12,
        52,
        255,
        70,
        192
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "crunch",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        },
        {
          "name": "cruncher",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  101,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          }
        },
        {
          "name": "checkpoint_claim_record",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  112,
                  97,
                  121,
                  111,
                  117,
                  116,
                  95,
                  99,
                  104,
                  101,
                  99,
                  107,
                  112,
                  111,
                  105,
                  110,
                  116,
                  95,
                  99,
                  108,
                  97,
                  105,
                  109,
                  95,
                  114,
                  101,
                  99,
                  111,
                  114,
                  100
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              },
              {
                "kind": "account",
                "path": "cruncher"
              }
            ]
          }
        },
        {
          "name": "model",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  109,
                  111,
                  100,
                  101,
                  108
                ]
              },
              {
                "kind": "account",
                "path": "cruncher"
              },
              {
                "kind": "arg",
                "path": "model_id"
              }
            ]
          }
        },
        {
          "name": "crunch_models",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  95,
                  109,
                  111,
                  100,
                  101,
                  108,
                  115
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "_crunch_name",
          "type": "string"
        },
        {
          "name": "model_id",
          "type": "string"
        },
        {
          "name": "signature",
          "type": "string"
        },
        {
          "name": "submission_id",
          "type": "string"
        },
        {
          "name": "resource_id",
          "type": "string"
        },
        {
          "name": "hardware_type",
          "type": "string"
        },
        {
          "name": "desired_state",
          "type": "string"
        },
        {
          "name": "metadata",
          "type": {
            "option": "bytes"
          }
        }
      ]
    },
    {
      "name": "add_model_phala",
      "discriminator": [
        11,
        69,
        245,
        157,
        102,
        254,
        18,
        217
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "crunch",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        },
        {
          "name": "cruncher",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  101,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          }
        },
        {
          "name": "checkpoint_claim_record",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  112,
                  97,
                  121,
                  111,
                  117,
                  116,
                  95,
                  99,
                  104,
                  101,
                  99,
                  107,
                  112,
                  111,
                  105,
                  110,
                  116,
                  95,
                  99,
                  108,
                  97,
                  105,
                  109,
                  95,
                  114,
                  101,
                  99,
                  111,
                  114,
                  100
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              },
              {
                "kind": "account",
                "path": "cruncher"
              }
            ]
          }
        },
        {
          "name": "model",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  109,
                  111,
                  100,
                  101,
                  108
                ]
              },
              {
                "kind": "account",
                "path": "cruncher"
              },
              {
                "kind": "arg",
                "path": "model_id"
              }
            ]
          }
        },
        {
          "name": "crunch_models",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  95,
                  109,
                  111,
                  100,
                  101,
                  108,
                  115
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "_crunch_name",
          "type": "string"
        },
        {
          "name": "model_id",
          "type": "string"
        },
        {
          "name": "metadata",
          "type": {
            "option": "bytes"
          }
        }
      ]
    },
    {
      "name": "add_or_update_model",
      "discriminator": [
        232,
        108,
        203,
        147,
        185,
        23,
        199,
        163
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "crunch",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        },
        {
          "name": "cruncher",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  101,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          }
        },
        {
          "name": "checkpoint_claim_record",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  112,
                  97,
                  121,
                  111,
                  117,
                  116,
                  95,
                  99,
                  104,
                  101,
                  99,
                  107,
                  112,
                  111,
                  105,
                  110,
                  116,
                  95,
                  99,
                  108,
                  97,
                  105,
                  109,
                  95,
                  114,
                  101,
                  99,
                  111,
                  114,
                  100
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              },
              {
                "kind": "account",
                "path": "cruncher"
              }
            ]
          }
        },
        {
          "name": "model",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  109,
                  111,
                  100,
                  101,
                  108
                ]
              },
              {
                "kind": "account",
                "path": "cruncher"
              },
              {
                "kind": "arg",
                "path": "model_id"
              }
            ]
          }
        },
        {
          "name": "crunch_models",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  95,
                  109,
                  111,
                  100,
                  101,
                  108,
                  115
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "_crunch_name",
          "type": "string"
        },
        {
          "name": "model_id",
          "type": "string"
        },
        {
          "name": "signature",
          "type": "string"
        },
        {
          "name": "submission_id",
          "type": {
            "option": "string"
          }
        },
        {
          "name": "resource_id",
          "type": {
            "option": "string"
          }
        },
        {
          "name": "hardware_type",
          "type": {
            "option": "string"
          }
        },
        {
          "name": "desired_state",
          "type": {
            "option": "string"
          }
        },
        {
          "name": "metadata",
          "type": {
            "option": "bytes"
          }
        }
      ]
    },
    {
      "name": "approve_coordinator",
      "discriminator": [
        178,
        181,
        209,
        117,
        58,
        199,
        93,
        123
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "coordinator",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "coordinator_authority"
              }
            ]
          }
        },
        {
          "name": "coordinator_authority"
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": []
    },
    {
      "name": "checkpoint_add_prizes",
      "discriminator": [
        67,
        1,
        67,
        58,
        228,
        237,
        100,
        91
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "crunch",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        },
        {
          "name": "coordinator",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          },
          "relations": [
            "crunch"
          ]
        },
        {
          "name": "checkpoint",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  112,
                  97,
                  121,
                  111,
                  117,
                  116,
                  95,
                  99,
                  104,
                  101,
                  99,
                  107,
                  112,
                  111,
                  105,
                  110,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              },
              {
                "kind": "arg",
                "path": "checkpoint_index"
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "_crunch_name",
          "type": "string"
        },
        {
          "name": "checkpoint_index",
          "type": "u16"
        },
        {
          "name": "prizes",
          "type": {
            "vec": {
              "defined": {
                "name": "CheckpointPrizeRequest"
              }
            }
          }
        },
        {
          "name": "is_last_batch",
          "type": "bool"
        }
      ]
    },
    {
      "name": "checkpoint_claim",
      "discriminator": [
        21,
        7,
        15,
        21,
        40,
        128,
        72,
        94
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "crunch",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        },
        {
          "name": "cruncher",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  101,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          }
        },
        {
          "name": "checkpoint",
          "writable": true
        },
        {
          "name": "checkpoint_claim_record",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  112,
                  97,
                  121,
                  111,
                  117,
                  116,
                  95,
                  99,
                  104,
                  101,
                  99,
                  107,
                  112,
                  111,
                  105,
                  110,
                  116,
                  95,
                  99,
                  108,
                  97,
                  105,
                  109,
                  95,
                  114,
                  101,
                  99,
                  111,
                  114,
                  100
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              },
              {
                "kind": "account",
                "path": "cruncher"
              }
            ]
          }
        },
        {
          "name": "cruncher_wallet_ata",
          "writable": true
        },
        {
          "name": "reward_vault",
          "writable": true,
          "relations": [
            "crunch"
          ]
        },
        {
          "name": "reward_vault_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  95,
                  100,
                  101,
                  112,
                  111,
                  115,
                  105,
                  116,
                  95,
                  97,
                  117,
                  116,
                  104,
                  111,
                  114,
                  105,
                  116,
                  121
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              }
            ]
          }
        },
        {
          "name": "usdc_mint"
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "_crunch_name",
          "type": "string"
        }
      ]
    },
    {
      "name": "checkpoint_initialize",
      "discriminator": [
        241,
        17,
        110,
        241,
        179,
        118,
        1,
        226
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "coordinator",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          },
          "relations": [
            "crunch"
          ]
        },
        {
          "name": "crunch",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        },
        {
          "name": "checkpoint",
          "writable": true
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "_crunch_name",
          "type": "string"
        },
        {
          "name": "prizes",
          "type": {
            "vec": {
              "defined": {
                "name": "CheckpointPrizeRequest"
              }
            }
          }
        },
        {
          "name": "is_last_batch",
          "type": "bool"
        }
      ]
    },
    {
      "name": "compact_unused_crunchers",
      "discriminator": [
        227,
        121,
        105,
        46,
        162,
        117,
        50,
        203
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "coordinator_config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "crunch",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        },
        {
          "name": "crunch_models",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  95,
                  109,
                  111,
                  100,
                  101,
                  108,
                  115
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              }
            ]
          }
        }
      ],
      "args": [
        {
          "name": "crunch_name",
          "type": "string"
        }
      ]
    },
    {
      "name": "coordinator_foundation_takeover",
      "discriminator": [
        103,
        157,
        14,
        193,
        120,
        200,
        24,
        197
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "crunch",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        },
        {
          "name": "coordinator",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "config.coordinator_admin_authority",
                "account": "CoordinatorConfig"
              }
            ]
          }
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "_crunch_name",
          "type": "string"
        }
      ]
    },
    {
      "name": "create_crunch",
      "discriminator": [
        96,
        32,
        216,
        154,
        159,
        140,
        229,
        59
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "coordinator",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          }
        },
        {
          "name": "crunch",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "name"
              }
            ]
          }
        },
        {
          "name": "reward_vault",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  95,
                  118,
                  97,
                  117,
                  108,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              }
            ]
          }
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "usdc_mint"
        },
        {
          "name": "reward_vault_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  95,
                  100,
                  101,
                  112,
                  111,
                  115,
                  105,
                  116,
                  95,
                  97,
                  117,
                  116,
                  104,
                  111,
                  114,
                  105,
                  116,
                  121
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              }
            ]
          }
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "name",
          "type": "string"
        },
        {
          "name": "payout_amount",
          "type": "u64"
        },
        {
          "name": "max_models_per_cruncher",
          "type": "u8"
        }
      ]
    },
    {
      "name": "create_cruncher",
      "discriminator": [
        19,
        121,
        103,
        195,
        168,
        103,
        183,
        221
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "cruncher",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  101,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "name",
          "type": "string"
        }
      ]
    },
    {
      "name": "drain_usdc",
      "discriminator": [
        28,
        238,
        28,
        152,
        4,
        223,
        68,
        146
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "coordinator",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          },
          "relations": [
            "crunch"
          ]
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "reward_vault",
          "writable": true
        },
        {
          "name": "reward_vault_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  95,
                  100,
                  101,
                  112,
                  111,
                  115,
                  105,
                  116,
                  95,
                  97,
                  117,
                  116,
                  104,
                  111,
                  114,
                  105,
                  116,
                  121
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              }
            ]
          }
        },
        {
          "name": "usdc_mint"
        },
        {
          "name": "user_ata",
          "writable": true
        },
        {
          "name": "crunch",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        },
        {
          "name": "checkpoint",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  112,
                  97,
                  121,
                  111,
                  117,
                  116,
                  95,
                  99,
                  104,
                  101,
                  99,
                  107,
                  112,
                  111,
                  105,
                  110,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              },
              {
                "kind": "account",
                "path": "crunch.last_checkpoint_index",
                "account": "Crunch"
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        }
      ],
      "args": [
        {
          "name": "_crunch_name",
          "type": "string"
        }
      ]
    },
    {
      "name": "end_crunch",
      "discriminator": [
        238,
        38,
        65,
        251,
        204,
        128,
        177,
        229
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "coordinator",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          },
          "relations": [
            "crunch"
          ]
        },
        {
          "name": "crunch",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "_crunch_name",
          "type": "string"
        }
      ]
    },
    {
      "name": "init_config",
      "discriminator": [
        23,
        235,
        115,
        232,
        168,
        96,
        1,
        231
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "config",
          "type": {
            "defined": {
              "name": "CoordinatorConfig"
            }
          }
        }
      ]
    },
    {
      "name": "init_crunch_registration_state",
      "discriminator": [
        234,
        196,
        153,
        228,
        108,
        139,
        142,
        190
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "coordinator_config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "crunch",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        },
        {
          "name": "crunch_registration_state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  95,
                  114,
                  101,
                  103,
                  105,
                  115,
                  116,
                  114,
                  97,
                  116,
                  105,
                  111,
                  110,
                  95,
                  115,
                  116,
                  97,
                  116,
                  101,
                  95,
                  50
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "crunch_name",
          "type": "string"
        },
        {
          "name": "next_index",
          "type": "u16"
        }
      ]
    },
    {
      "name": "payout_margin",
      "discriminator": [
        144,
        85,
        135,
        192,
        182,
        206,
        90,
        59
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "coordinator",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          },
          "relations": [
            "crunch"
          ]
        },
        {
          "name": "crunch",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        },
        {
          "name": "foundation_wallet_ata",
          "writable": true
        },
        {
          "name": "burn_wallet_ata",
          "writable": true
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "reward_vault",
          "writable": true,
          "relations": [
            "crunch"
          ]
        },
        {
          "name": "reward_vault_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  95,
                  100,
                  101,
                  112,
                  111,
                  115,
                  105,
                  116,
                  95,
                  97,
                  117,
                  116,
                  104,
                  111,
                  114,
                  105,
                  116,
                  121
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              }
            ]
          }
        },
        {
          "name": "usdc_mint"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        }
      ],
      "args": [
        {
          "name": "_crunch_name",
          "type": "string"
        }
      ]
    },
    {
      "name": "propose_coordinator_authority",
      "discriminator": [
        200,
        31,
        76,
        98,
        228,
        240,
        175,
        1
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "pub_key",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "purge_unused_crunchers",
      "discriminator": [
        63,
        133,
        22,
        136,
        245,
        142,
        246,
        123
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "coordinator_config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "crunch",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        },
        {
          "name": "crunch_models",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  95,
                  109,
                  111,
                  100,
                  101,
                  108,
                  115
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              }
            ]
          }
        },
        {
          "name": "crunch_registration_state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  95,
                  114,
                  101,
                  103,
                  105,
                  115,
                  116,
                  114,
                  97,
                  116,
                  105,
                  111,
                  110,
                  95,
                  115,
                  116,
                  97,
                  116,
                  101,
                  95,
                  50
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              }
            ]
          }
        }
      ],
      "args": [
        {
          "name": "crunch_name",
          "type": "string"
        }
      ]
    },
    {
      "name": "register_coordinator",
      "discriminator": [
        121,
        226,
        32,
        53,
        224,
        85,
        180,
        163
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "coordinator",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          }
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "name",
          "type": "string"
        }
      ]
    },
    {
      "name": "register_cruncher",
      "discriminator": [
        240,
        148,
        38,
        204,
        41,
        66,
        44,
        67
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "cruncher",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  101,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          }
        },
        {
          "name": "payout_claim_record",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  112,
                  97,
                  121,
                  111,
                  117,
                  116,
                  95,
                  99,
                  104,
                  101,
                  99,
                  107,
                  112,
                  111,
                  105,
                  110,
                  116,
                  95,
                  99,
                  108,
                  97,
                  105,
                  109,
                  95,
                  114,
                  101,
                  99,
                  111,
                  114,
                  100
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              },
              {
                "kind": "account",
                "path": "cruncher"
              }
            ]
          }
        },
        {
          "name": "crunch_registration_state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  95,
                  114,
                  101,
                  103,
                  105,
                  115,
                  116,
                  114,
                  97,
                  116,
                  105,
                  111,
                  110,
                  95,
                  115,
                  116,
                  97,
                  116,
                  101,
                  95,
                  50
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              }
            ]
          }
        },
        {
          "name": "crunch",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "_crunch_name",
          "type": "string"
        },
        {
          "name": "name",
          "type": "string"
        }
      ]
    },
    {
      "name": "reject_coordinator",
      "discriminator": [
        15,
        37,
        115,
        61,
        138,
        215,
        196,
        94
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "coordinator",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "coordinator_authority"
              }
            ]
          }
        },
        {
          "name": "coordinator_authority"
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": []
    },
    {
      "name": "reset_crunch_crunchers",
      "discriminator": [
        79,
        6,
        77,
        179,
        140,
        145,
        55,
        234
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "coordinator_config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "crunch",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        }
      ],
      "args": [
        {
          "name": "crunch_name",
          "type": "string"
        }
      ]
    },
    {
      "name": "start_crunch",
      "discriminator": [
        156,
        215,
        54,
        144,
        94,
        4,
        59,
        219
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "crunch",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        },
        {
          "name": "coordinator",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  111,
                  114,
                  100,
                  105,
                  110,
                  97,
                  116,
                  111,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          },
          "relations": [
            "crunch"
          ]
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "reward_vault",
          "writable": true,
          "relations": [
            "crunch"
          ]
        },
        {
          "name": "reward_vault_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  95,
                  100,
                  101,
                  112,
                  111,
                  115,
                  105,
                  116,
                  95,
                  97,
                  117,
                  116,
                  104,
                  111,
                  114,
                  105,
                  116,
                  121
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              }
            ]
          }
        },
        {
          "name": "usdc_mint"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "_crunch_name",
          "type": "string"
        }
      ]
    },
    {
      "name": "update_burn_margin_percentage",
      "discriminator": [
        121,
        118,
        144,
        172,
        59,
        244,
        111,
        65
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "burn_margin_percentage",
          "type": "u8"
        }
      ]
    },
    {
      "name": "update_burn_wallet",
      "discriminator": [
        118,
        5,
        254,
        117,
        118,
        67,
        107,
        243
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "burn_wallet",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "update_claim_expiry_seconds",
      "discriminator": [
        237,
        91,
        212,
        109,
        217,
        2,
        12,
        116
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "claim_expiry_seconds",
          "type": "u32"
        }
      ]
    },
    {
      "name": "update_foundation_margin_percentage",
      "discriminator": [
        83,
        224,
        145,
        237,
        45,
        56,
        136,
        162
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "foundation_margin_percentage",
          "type": "u8"
        }
      ]
    },
    {
      "name": "update_foundation_wallet",
      "discriminator": [
        148,
        197,
        253,
        104,
        223,
        0,
        217,
        175
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  111,
                  110,
                  102,
                  105,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "foundation_wallet",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "update_model",
      "discriminator": [
        76,
        230,
        44,
        16,
        103,
        83,
        24,
        73
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "crunch",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104
                ]
              },
              {
                "kind": "arg",
                "path": "crunch_name"
              }
            ]
          }
        },
        {
          "name": "cruncher",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  101,
                  114
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          }
        },
        {
          "name": "checkpoint_claim_record",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  112,
                  97,
                  121,
                  111,
                  117,
                  116,
                  95,
                  99,
                  104,
                  101,
                  99,
                  107,
                  112,
                  111,
                  105,
                  110,
                  116,
                  95,
                  99,
                  108,
                  97,
                  105,
                  109,
                  95,
                  114,
                  101,
                  99,
                  111,
                  114,
                  100
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              },
              {
                "kind": "account",
                "path": "cruncher"
              }
            ]
          }
        },
        {
          "name": "model",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  109,
                  111,
                  100,
                  101,
                  108
                ]
              },
              {
                "kind": "account",
                "path": "cruncher"
              },
              {
                "kind": "arg",
                "path": "model_id"
              }
            ]
          }
        },
        {
          "name": "crunch_models",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  99,
                  114,
                  117,
                  110,
                  99,
                  104,
                  95,
                  109,
                  111,
                  100,
                  101,
                  108,
                  115
                ]
              },
              {
                "kind": "account",
                "path": "crunch"
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "_crunch_name",
          "type": "string"
        },
        {
          "name": "model_id",
          "type": "string"
        },
        {
          "name": "signature",
          "type": "string"
        },
        {
          "name": "submission_id",
          "type": {
            "option": "string"
          }
        },
        {
          "name": "resource_id",
          "type": {
            "option": "string"
          }
        },
        {
          "name": "hardware_type",
          "type": {
            "option": "string"
          }
        },
        {
          "name": "desired_state",
          "type": {
            "option": "string"
          }
        },
        {
          "name": "metadata",
          "type": {
            "option": "bytes"
          }
        }
      ]
    }
  ],
  "accounts": [
    {
      "name": "Checkpoint",
      "discriminator": [
        199,
        62,
        186,
        186,
        98,
        119,
        211,
        139
      ]
    },
    {
      "name": "CheckpointClaimRecord",
      "discriminator": [
        238,
        107,
        71,
        10,
        67,
        183,
        122,
        119
      ]
    },
    {
      "name": "Coordinator",
      "discriminator": [
        234,
        133,
        61,
        140,
        173,
        3,
        10,
        188
      ]
    },
    {
      "name": "CoordinatorConfig",
      "discriminator": [
        172,
        64,
        171,
        72,
        168,
        230,
        93,
        208
      ]
    },
    {
      "name": "Crunch",
      "discriminator": [
        93,
        242,
        143,
        57,
        202,
        120,
        98,
        39
      ]
    },
    {
      "name": "CrunchModels",
      "discriminator": [
        242,
        169,
        218,
        113,
        199,
        15,
        159,
        109
      ]
    },
    {
      "name": "CrunchRegistrationState",
      "discriminator": [
        89,
        6,
        107,
        46,
        254,
        107,
        173,
        8
      ]
    },
    {
      "name": "Cruncher",
      "discriminator": [
        11,
        79,
        234,
        93,
        197,
        78,
        203,
        37
      ]
    },
    {
      "name": "Model",
      "discriminator": [
        152,
        221,
        247,
        122,
        185,
        125,
        223,
        151
      ]
    }
  ],
  "events": [
    {
      "name": "CrunchEnded",
      "discriminator": [
        146,
        22,
        222,
        11,
        208,
        215,
        108,
        102
      ]
    },
    {
      "name": "CrunchPaidout",
      "discriminator": [
        61,
        117,
        193,
        27,
        89,
        13,
        234,
        28
      ]
    },
    {
      "name": "CrunchStarted",
      "discriminator": [
        139,
        116,
        227,
        58,
        40,
        70,
        113,
        23
      ]
    },
    {
      "name": "CrunchUpdated",
      "discriminator": [
        115,
        208,
        67,
        115,
        153,
        80,
        230,
        63
      ]
    },
    {
      "name": "CruncherMarginsPaidout",
      "discriminator": [
        158,
        184,
        224,
        242,
        223,
        147,
        189,
        46
      ]
    },
    {
      "name": "CruncherWalletPaidout",
      "discriminator": [
        231,
        32,
        184,
        83,
        67,
        121,
        151,
        95
      ]
    }
  ],
  "errors": [
    {
      "code": 6000,
      "name": "OnlyAdminAllowed",
      "msg": "Only Admin Can Access This Functionality"
    },
    {
      "code": 6001,
      "name": "OnlyAdminCanManageCoordinator",
      "msg": "Only Admin Can Manage Coordinator"
    },
    {
      "code": 6002,
      "name": "OnlyApprovedCoordinatorsAllowed",
      "msg": "Only Approved Coordinators are allowed"
    },
    {
      "code": 6003,
      "name": "CruncherNotRegisteredForCrunch",
      "msg": "Cruncher Not Registered For Crunch"
    },
    {
      "code": 6004,
      "name": "CruncherAlreadyHasMaxModels",
      "msg": "Cruncher already has the maximum number of models"
    },
    {
      "code": 6005,
      "name": "InvalidCrunchStateToEnd",
      "msg": "Crunch is not in the started state"
    },
    {
      "code": 6006,
      "name": "InvalidCrunchStateToPayoutMargin",
      "msg": "Crunch is not in end state"
    },
    {
      "code": 6007,
      "name": "OnlyAdminCanStartTheCrunch",
      "msg": "Only Crunch Authority can start a crunch"
    },
    {
      "code": 6008,
      "name": "InvalidCrunchStateToStart",
      "msg": "Crunch is not in the created state"
    },
    {
      "code": 6009,
      "name": "RewardVaultInsufficientFunds",
      "msg": "Reward vault has insufficient funds"
    },
    {
      "code": 6010,
      "name": "CrunchMarginNotPaidout",
      "msg": "Crunch margins are not paid out yet"
    },
    {
      "code": 6011,
      "name": "OnlyAdminCanWithdrawUsdcTheCrunch",
      "msg": "Only Crunch Authority can withdraw USDC"
    },
    {
      "code": 6012,
      "name": "ModelToUpdateNotFound",
      "msg": "Model to update not found"
    },
    {
      "code": 6013,
      "name": "OnlyCrunchOwnerCanManagePayoutCheckpoint",
      "msg": "Only the crunch owner can manage a payout checkpoint"
    },
    {
      "code": 6014,
      "name": "TooManyPrizes",
      "msg": "Too many prizes"
    },
    {
      "code": 6015,
      "name": "NoPrizes",
      "msg": "No prizes"
    },
    {
      "code": 6016,
      "name": "OnlyOwnerCanUpdateModel",
      "msg": "Only owner can update the model"
    },
    {
      "code": 6017,
      "name": "CrunchMustBeStarted",
      "msg": "Crunch must be started"
    },
    {
      "code": 6018,
      "name": "NameTooLong",
      "msg": "Name must be less than or equal to 32 characters"
    },
    {
      "code": 6019,
      "name": "MetadataTooLong",
      "msg": "Metadata must be less than or equal to 1000 bytes"
    },
    {
      "code": 6020,
      "name": "NoProposedAdmin",
      "msg": "No proposed admin"
    },
    {
      "code": 6021,
      "name": "OnlyProposedAdminCanAccept",
      "msg": "Only proposed admin can accept"
    },
    {
      "code": 6022,
      "name": "InvalidBurnMarginPercentage",
      "msg": "Invalid burn margin percentage"
    },
    {
      "code": 6023,
      "name": "InvalidFoundationMarginPercentage",
      "msg": "Invalid foundation margin percentage"
    },
    {
      "code": 6024,
      "name": "PrizesAlreadyLoaded",
      "msg": "Prizes already loaded"
    },
    {
      "code": 6025,
      "name": "CheckpointTooYoung",
      "msg": "Checkpoint too young"
    },
    {
      "code": 6026,
      "name": "OneClaimablePrizePerCheckpointPerCruncher",
      "msg": "One claimable prize per checkpoint per cruncher"
    },
    {
      "code": 6027,
      "name": "InvalidCheckpointIndex",
      "msg": "Invalid checkpoint index"
    }
  ],
  "types": [
    {
      "name": "ActiveModel",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "model_key",
            "type": "pubkey"
          },
          {
            "name": "desired_state",
            "type": {
              "defined": {
                "name": "DesiredState"
              }
            }
          },
          {
            "name": "cruncher_index",
            "type": "u16"
          }
        ]
      }
    },
    {
      "name": "Checkpoint",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "status",
            "type": {
              "defined": {
                "name": "CheckpointStatus"
              }
            }
          },
          {
            "name": "crunch",
            "type": "pubkey"
          },
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "coordinator",
            "type": "pubkey"
          },
          {
            "name": "index",
            "type": "u16"
          },
          {
            "name": "timestamp",
            "type": "i64"
          },
          {
            "name": "prizes",
            "type": {
              "vec": {
                "defined": {
                  "name": "CheckpointPrize"
                }
              }
            }
          }
        ]
      }
    },
    {
      "name": "CheckpointClaimRecord",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "cruncher_index",
            "type": "u16"
          },
          {
            "name": "crunch",
            "type": "pubkey"
          },
          {
            "name": "checkpoint_index",
            "type": "u16"
          },
          {
            "name": "bump",
            "type": "u8"
          }
        ]
      }
    },
    {
      "name": "CheckpointPrize",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "prize",
            "type": "u64"
          },
          {
            "name": "cruncher_index",
            "type": "u16"
          },
          {
            "name": "claimed",
            "type": "bool"
          }
        ]
      }
    },
    {
      "name": "CheckpointPrizeRequest",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "prize",
            "type": "u64"
          },
          {
            "name": "cruncher_index",
            "type": "u16"
          }
        ]
      }
    },
    {
      "name": "CheckpointStatus",
      "type": {
        "kind": "enum",
        "variants": [
          {
            "name": "LoadingPrizes"
          },
          {
            "name": "LoadedPrizes"
          },
          {
            "name": "FullyClaimed"
          }
        ]
      }
    },
    {
      "name": "Coordinator",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "state",
            "type": {
              "defined": {
                "name": "CoordinatorState"
              }
            }
          },
          {
            "name": "owner",
            "type": "pubkey"
          },
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "name",
            "type": "string"
          }
        ]
      }
    },
    {
      "name": "CoordinatorConfig",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "coordinator_admin_authority",
            "type": "pubkey"
          },
          {
            "name": "proposed_coordinator_admin_authority",
            "type": {
              "option": "pubkey"
            }
          },
          {
            "name": "reward_program_authority",
            "type": "pubkey"
          },
          {
            "name": "slash_custody",
            "type": "pubkey"
          },
          {
            "name": "usdc_mint",
            "type": "pubkey"
          },
          {
            "name": "burn_margin_percentage",
            "type": "u8"
          },
          {
            "name": "foundation_margin_percentage",
            "type": "u8"
          },
          {
            "name": "foundation_wallet",
            "type": "pubkey"
          },
          {
            "name": "burn_wallet",
            "type": "pubkey"
          },
          {
            "name": "claim_expiry_seconds",
            "type": "u32"
          }
        ]
      }
    },
    {
      "name": "CoordinatorState",
      "type": {
        "kind": "enum",
        "variants": [
          {
            "name": "Pending"
          },
          {
            "name": "Approved"
          },
          {
            "name": "Rejected"
          }
        ]
      }
    },
    {
      "name": "Crunch",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "coordinator",
            "type": "pubkey"
          },
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "reward_vault_authority_bump",
            "type": "u8"
          },
          {
            "name": "reward_vault",
            "type": "pubkey"
          },
          {
            "name": "reward_vault_bump",
            "type": "u8"
          },
          {
            "name": "state",
            "type": {
              "defined": {
                "name": "CrunchState"
              }
            }
          },
          {
            "name": "last_checkpoint_index",
            "type": "u16"
          },
          {
            "name": "max_models_per_cruncher",
            "type": "u8"
          },
          {
            "name": "payout_amount",
            "type": "u64"
          },
          {
            "name": "coordinator_node_ip",
            "type": "string"
          },
          {
            "name": "name",
            "type": "string"
          },
          {
            "name": "crunchers",
            "type": {
              "vec": "pubkey"
            }
          }
        ]
      }
    },
    {
      "name": "CrunchEnded",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "crunch_pubkey",
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "CrunchModels",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "initialized",
            "type": "bool"
          },
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "crunch_id",
            "type": "pubkey"
          },
          {
            "name": "models",
            "type": {
              "vec": {
                "defined": {
                  "name": "ActiveModel"
                }
              }
            }
          }
        ]
      }
    },
    {
      "name": "CrunchPaidout",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "crunch_pubkey",
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "CrunchRegistrationState",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "crunch",
            "type": "pubkey"
          },
          {
            "name": "next_index",
            "type": "u16"
          }
        ]
      }
    },
    {
      "name": "CrunchStarted",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "crunch_pubkey",
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "CrunchState",
      "type": {
        "kind": "enum",
        "variants": [
          {
            "name": "Created"
          },
          {
            "name": "Started"
          },
          {
            "name": "Ended"
          },
          {
            "name": "MarginPaidout"
          },
          {
            "name": "Drained"
          }
        ]
      }
    },
    {
      "name": "CrunchUpdated",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "crunch_pubkey",
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "Cruncher",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "initialized",
            "type": "bool"
          },
          {
            "name": "owner",
            "type": "pubkey"
          },
          {
            "name": "wallet",
            "type": "pubkey"
          },
          {
            "name": "name",
            "type": "string"
          }
        ]
      }
    },
    {
      "name": "CruncherMarginsPaidout",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "cruncher_pubkey",
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "CruncherWalletPaidout",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "cruncher_pubkey",
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "DesiredState",
      "type": {
        "kind": "enum",
        "variants": [
          {
            "name": "START"
          },
          {
            "name": "STOP"
          }
        ]
      }
    },
    {
      "name": "HardwareType",
      "type": {
        "kind": "enum",
        "variants": [
          {
            "name": "CPU"
          },
          {
            "name": "GPU"
          }
        ]
      }
    },
    {
      "name": "Model",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "initialized",
            "type": "bool"
          },
          {
            "name": "owner",
            "type": "pubkey"
          },
          {
            "name": "model_host",
            "type": {
              "defined": {
                "name": "ModelHost"
              }
            }
          },
          {
            "name": "hardware_type",
            "type": {
              "defined": {
                "name": "HardwareType"
              }
            }
          },
          {
            "name": "submission_id",
            "type": "string"
          },
          {
            "name": "resource_id",
            "type": "string"
          },
          {
            "name": "id",
            "type": "string"
          },
          {
            "name": "signature",
            "type": "string"
          },
          {
            "name": "metadata",
            "type": "bytes"
          }
        ]
      }
    },
    {
      "name": "ModelHost",
      "type": {
        "kind": "enum",
        "variants": [
          {
            "name": "PHALA"
          },
          {
            "name": "AWSECS"
          }
        ]
      }
    }
  ],
  "constants": [
    {
      "name": "CHECKPOINT_CLAIM_RECORD_SEED",
      "type": "string",
      "value": "\"payout_checkpoint_claim_record\""
    },
    {
      "name": "CHECKPOINT_SEED",
      "type": "string",
      "value": "\"payout_checkpoint\""
    },
    {
      "name": "CONFIG_SEED",
      "type": "string",
      "value": "\"config\""
    },
    {
      "name": "COORDINATOR_SEED",
      "type": "string",
      "value": "\"coordinator\""
    },
    {
      "name": "CRUNCHER_SEED",
      "type": "string",
      "value": "\"cruncher\""
    },
    {
      "name": "CRUNCH_AUTHORITY_SEED",
      "type": "string",
      "value": "\"crunch_deposit_authority\""
    },
    {
      "name": "CRUNCH_MODELS_SEED",
      "type": "string",
      "value": "\"crunch_models\""
    },
    {
      "name": "CRUNCH_REGISTRATION_STATE_SEED",
      "type": "string",
      "value": "\"crunch_registration_state_2\""
    },
    {
      "name": "CRUNCH_SEED",
      "type": "string",
      "value": "\"crunch\""
    },
    {
      "name": "CRUNCH_VAULT_SEED",
      "type": "string",
      "value": "\"crunch_vault\""
    },
    {
      "name": "LEADERBOARD_SEED",
      "type": "string",
      "value": "\"leaderboard\""
    },
    {
      "name": "MAX_BURN_MARGIN_PERCENTAGE",
      "type": "u8",
      "value": "10"
    },
    {
      "name": "MAX_COORDINATOR_NAME_LENGTH",
      "type": "u8",
      "value": "32"
    },
    {
      "name": "MAX_CRUNCHER_NAME_LENGTH",
      "type": "u8",
      "value": "32"
    },
    {
      "name": "MAX_CRUNCH_NAME_LENGTH",
      "type": "u8",
      "value": "32"
    },
    {
      "name": "MAX_FOUNDATION_MARGIN_PERCENTAGE",
      "type": "u8",
      "value": "10"
    },
    {
      "name": "MAX_METADATA_FIELD_LENGTH",
      "type": "u16",
      "value": "1000"
    },
    {
      "name": "MAX_MODEL_FIELD_LENGTH",
      "type": "u8",
      "value": "40"
    },
    {
      "name": "MAX_PRIZES_IN_BATCH",
      "type": "u8",
      "value": "60"
    },
    {
      "name": "MAX_PRIZES_IN_CHECKPOINT",
      "type": "u16",
      "value": "920"
    },
    {
      "name": "MODEL_SEED",
      "type": "string",
      "value": "\"model\""
    }
  ]
}